const TUI_POLISH_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['Numer', 'Numer karty'],
  cardExpiry: ['Wygasa', 'Data ważności']
};
const TUI_POLISH_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['Kolor', 'Gradient'],
  toolbarTools: {
    undo: 'Cofnij',
    redo: 'Ponów',
    font: 'Czcionka',
    fontStyle: 'Styl czcionki',
    fontSize: 'Rozmiar czcionki',
    bold: 'Pogrubienie',
    italic: 'Kursywa',
    underline: 'Podkreślenie',
    strikeThrough: 'Przekreślenie',
    justify: 'Wyrównanie',
    justifyLeft: 'Wyrównanie do lewej',
    justifyCenter: 'Wyrównanie do środka',
    justifyRight: 'Wyrównanie do prawej',
    justifyFull: 'Justowanie',
    list: 'Lista',
    indent: 'Zwiększ wcięcie',
    outdent: 'Zmniejsz wcięcie',
    unorderedList: 'Lista punktowana',
    orderedList: 'Lista numerowana',
    quote: 'Cytat',
    foreColor: 'Kolor tekstu',
    backColor: 'Kolor tła',
    hiliteColor: 'Kolor zaznaczenia',
    clear: 'Wyczyść',
    link: 'Link',
    attach: 'Załącz plik',
    tex: 'Wstaw wzór',
    code: 'Kod',
    image: 'Wstaw ilustrację',
    insertHorizontalRule: 'Wstaw separator',
    superscript: 'Indeks górny',
    subscript: 'Indeks dolny',
    insertTable: 'Wstaw tabelę',
    insertGroup: 'Insert group',
    hiliteGroup: 'Hilite group',
    removeGroup: 'Remove group',
    insertAnchor: 'Insert anchor',
    mergeCells: 'Scal komórki',
    splitCells: 'Podziel komórki',
    rowsColumnsManaging: 'Zarządzaj wierszami i kolumnami',
    cellColor: 'Kolor komórki',
    setDetails: 'Details',
    removeDetails: 'Remove details'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'anchor'
  },
  editorTableCommands: [['Wstaw kolumnę przed', 'Wstaw kolumnę po'], ['Wstaw wiersz przed', 'Wstaw wiersz po'], ['Usuń kolumnę', 'Usuń wiersz']],
  editorCodeOptions: ['Kod w tekście', 'Kod w bloku'],
  editorFontOptions: {
    small: 'Small',
    normal: 'Normalny',
    large: 'Large',
    title: 'Tytuł',
    subtitle: 'Podtytuł'
  }
};
const TUI_POLISH_LANGUAGE_ADDON_TABLE = {
  showHideText: 'Pokaż/Ukryj',
  paginationTexts: {
    pages: 'Strony',
    linesPerPage: 'Wierszy na stronę',
    of: 'z'
  }
};
const TUI_POLISH_LANGUAGE_COUNTRIES = {
  AD: 'Andora',
  AE: 'Zjednoczone Emiraty Arabskie',
  AF: 'Afganistan',
  AG: 'Antigua i Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AM: 'Armenia',
  AO: 'Angola',
  AR: 'Argentyna',
  AT: 'Austria',
  AU: 'Australia',
  AW: 'Aruba',
  AZ: 'Azerbejdżan',
  BA: 'Bośnia i Hercegowina',
  BB: 'Barbados',
  BD: 'Bangladesz',
  BE: 'Belgia',
  BF: 'Burkina Faso',
  BG: 'Bułgaria',
  BH: 'Bahrajn',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'Święty Barthélemy',
  BM: 'Bermudy',
  BN: 'Brunei',
  BO: 'Boliwia',
  BQ: 'Bonaire, Sint Eustatius i Saba',
  BR: 'Brazylia',
  BS: 'Bahamy',
  BT: 'Bhutan',
  BW: 'Botswana',
  BY: 'Białoruś',
  BZ: 'Belize',
  CA: 'Kanada',
  CD: 'Demokratyczna Republika Konga',
  CF: 'Republika Środkowoafrykańska',
  CG: 'Kongo',
  CH: 'Szwajcaria',
  CI: 'Wybrzeże Kości Słoniowej',
  CL: 'Chile',
  CM: 'Kamerun',
  CN: 'Chiny',
  CO: 'Kolumbia',
  CR: 'Kostaryka',
  CU: 'Kuba',
  CV: 'Republika Zielonego Przylądka',
  CW: 'Curaçao',
  CY: 'Cypr',
  CZ: 'Czechy',
  DE: 'Niemcy',
  DJ: 'Dżibuti ',
  DK: 'Dania',
  DM: 'Dominika',
  DO: 'Dominikana',
  DZ: 'Algieria',
  EC: 'Ekwador',
  EE: 'Estonia',
  EG: 'Egipt',
  ER: 'Erytrea',
  ES: 'Hiszpania',
  ET: 'Etiopia',
  FI: 'Finlandia',
  FJ: 'Fidżi',
  FK: 'Falklandy',
  FM: 'Mikronezja',
  FR: 'Francja',
  GA: 'Gabon',
  GB: 'Wielka Brytania',
  GD: 'Grenada',
  GE: 'Gruzja',
  GF: 'Gujana',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Grenlandia',
  GM: 'Gambia',
  GN: 'Gwinea',
  GP: 'Gwadelupa',
  GQ: 'Gwinea Równikowa',
  GR: 'Grecja',
  GT: 'Gwatemala',
  GW: 'Gwinea Bissau',
  GY: 'Gujana',
  HK: 'Hongkong',
  HN: 'Honduras',
  HR: 'Chorwacja',
  HT: 'Haiti',
  HU: 'Węgry',
  ID: 'Indonezja',
  IE: 'Irlandia',
  IL: 'Izrael',
  IN: 'Indie',
  IQ: 'Irak',
  IR: 'Iran',
  IS: 'Islandia',
  IT: 'Włochy',
  JM: 'Jamajka',
  JO: 'Jordania',
  JP: 'Japonia',
  KE: 'Kenia',
  KG: 'Kirgistan',
  KH: 'Kambodża',
  KM: 'Komory',
  KN: 'Saint Kitts i Nevis',
  KP: 'Korea Północna',
  KR: 'Korea Południowa',
  KW: 'Kuwejt',
  KY: 'Kajmany',
  KZ: 'Kazachstan',
  LA: 'Laos',
  LB: 'Liban',
  LC: 'Saint Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Litwa',
  LU: 'Luksemburg',
  LV: 'Łotwa',
  LY: 'Libia',
  MA: 'Maroko',
  MC: 'Monako',
  MD: 'Mołdawia',
  ME: 'Czarnogóra',
  MF: 'Święty Marcin',
  MG: 'Madagaskar',
  MK: 'Macedonia',
  ML: 'Mali',
  MM: 'Mjanma (Birma)',
  MN: 'Mongolia',
  MO: 'Makau',
  MQ: 'Martynika',
  MR: 'Mauretania',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Malediwy',
  MW: 'Malawi',
  MX: 'Meksyk',
  MY: 'Malezja',
  MZ: 'Mozambik',
  NA: 'Namibia',
  NC: 'Nowa Kaledonia',
  NE: 'Niger',
  NG: 'Nigeria',
  NI: 'Nikaragua',
  NL: 'Holandia',
  NO: 'Norwegia',
  NP: 'Nepal',
  NZ: 'Nowa Zelandia',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'Polinezja Francuska',
  PG: 'Papua-Nowa Gwinea',
  PH: 'Filipiny',
  PK: 'Pakistan',
  PL: 'Polska',
  PT: 'Portugalia',
  PW: 'Palau',
  PY: 'Paragwaj',
  QA: 'Katar',
  RE: 'Posiedzenie',
  RO: 'Rumunia',
  RS: 'Serbia',
  RU: 'Rosja',
  RW: 'Rwanda',
  SA: 'Arabia Saudyjska',
  SB: 'Wyspy Salomona',
  SC: 'Seszele',
  SD: 'Sudan',
  SE: 'Szwecja',
  SG: 'Singapur',
  SH: 'Wyspa Świętej Heleny',
  SI: 'Słowenia',
  SK: 'Słowacja',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Surinam',
  ST: 'Wyspy Świętego Tomasza i Książęca',
  SV: 'Salwador',
  SX: 'Sint Maarten',
  SY: 'Syria',
  SZ: 'Eswatini',
  TC: 'Turks i Caicos',
  TD: 'Czad',
  TG: 'Togo',
  TH: 'Tajlandia',
  TJ: 'Tadżykistan',
  TL: 'Timor Wschodni',
  TM: 'Turkmenistan',
  TN: 'Tunezja',
  TO: 'Tonga',
  TR: 'Turcja',
  TT: 'Trynidad i Tobago',
  TW: 'Tajwan',
  TZ: 'Tanzania',
  UA: 'Ukraina',
  UG: 'Uganda',
  US: 'Stany Zjednoczone',
  UY: 'Urugwaj',
  UZ: 'Uzbekistan',
  VC: 'Saint Vincent i Grenadyny',
  VE: 'Wenezuela',
  VG: 'Brytyjskie Wyspy Dziewicze',
  VN: 'Wietnam',
  VU: 'Vanuatu',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Jemen',
  YT: 'Majotta',
  ZA: 'Republika Południowej Afryki',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AC: 'Ascension Island',
  AS: 'American Samoa',
  AX: 'Åland Islands',
  CC: 'Cocos (Keeling) Islands',
  CK: 'Cook Islands',
  CX: 'Christmas Island',
  EH: 'Western Sahara',
  FO: 'Faroe Islands',
  GG: 'Guernsey',
  GU: 'Guam',
  IM: 'Isle of Man',
  JE: 'Jersey',
  IO: 'British Indian Ocean Territory',
  KI: 'Kiribati',
  MH: 'Marshall Islands',
  MP: 'Northern Mariana Islands',
  NF: 'Norfolk Island',
  NR: 'Nauru',
  NU: 'Niue',
  PM: 'Saint Pierre and Miquelon',
  PR: 'Puerto Rico',
  PS: 'Palestine',
  SJ: 'Svalbard and Jan Mayen',
  SS: 'South Sudan',
  TA: 'Tristan da Cunha',
  TK: 'Tokelau',
  TV: 'Tuvalu',
  VA: 'Holy See',
  VI: 'Virgin Islands',
  WF: 'Wallis and Futuna'
};
const TUI_POLISH_LANGUAGE_CORE = {
  months: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'],
  close: 'Zamknij',
  clear: 'Wyczyść pole',
  nothingFoundMessage: 'Nic nie znaleziono',
  defaultErrorMessage: 'Nieprawidłowa wartość',
  spinTexts: ['Poprzedni', 'Następny'],
  shortWeekDays: ['Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob', 'Nie'],
  countries: TUI_POLISH_LANGUAGE_COUNTRIES
};
const TUI_POLISH_LANGUAGE_KIT = {
  cancel: 'Anuluj',
  done: 'Gotowe',
  more: 'Więcej',
  otherDate: 'Inna data...',
  showAll: 'Show all',
  hide: 'Hide',
  mobileCalendarTexts: ['Wybierz dzień', 'Wybierz zakres', 'Wybierz dni'],
  range: ['od', 'do'],
  countTexts: ['Plus', 'Minus'],
  time: {
    'HH:MM': 'HH:MM',
    'HH:MM AA': 'HH:MM AA',
    'HH:MM:SS': 'HH:MM:SS',
    'HH:MM:SS AA': 'HH:MM:SS AA',
    'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
    'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA'
  },
  dateTexts: {
    DMY: 'dd.mm.rrrr',
    MDY: 'mm.dd.rrrr',
    YMD: 'rrrr.mm.dd'
  },
  digitalInformationUnits: ['B', 'KiB', 'MiB'],
  passwordTexts: ['Pokaż hasło', 'Ukryj hasło'],
  copyTexts: ['Kopiuj', 'Skopiowano'],
  shortCalendarMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
  pagination: ['Poprzednia strona', 'Następna strona'],
  fileTexts: {
    loadingError: 'Błąd ładowania',
    preview: 'Podgląd',
    remove: 'Usuń'
  },
  inputFileTexts: {
    defaultLabelSingle: 'lub przeciągnij\u00A0tutaj',
    defaultLabelMultiple: 'lub przeciągnij\u00A0tutaj',
    defaultLinkSingle: 'Wybierz plik',
    defaultLinkMultiple: 'Wybierz pliki',
    maxSizeRejectionReason: 'Plik przekracza rozmiar ',
    formatRejectionReason: 'Nieprawidłowy format pliku',
    drop: 'Przeciągnij plik tutaj',
    dropMultiple: 'Przeciągnij pliki tutaj'
  },
  multiSelectTexts: {
    all: 'Zaznacz wszystko',
    none: 'Nie zaznaczaj'
  },
  confirm: {
    yes: 'Tak',
    no: 'Nie'
  },
  previewTexts: {
    rotate: 'Obracać się'
  },
  zoomTexts: {
    zoomOut: 'Pomniejsz',
    zoomIn: 'Zbliżenie',
    reset: 'Resetowanie'
  },
  phoneSearch: 'Nuna imaluunniit kode allaguk'
};
const TUI_POLISH_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};
const TUI_POLISH_LANGUAGE = {
  name: 'polish',
  ...TUI_POLISH_LANGUAGE_CORE,
  ...TUI_POLISH_LANGUAGE_KIT,
  ...TUI_POLISH_LANGUAGE_ADDON_TABLE,
  ...TUI_POLISH_LANGUAGE_ADDON_COMMERCE,
  ...TUI_POLISH_LANGUAGE_ADDON_EDITOR,
  ...TUI_POLISH_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_POLISH_LANGUAGE, TUI_POLISH_LANGUAGE_ADDON_COMMERCE, TUI_POLISH_LANGUAGE_ADDON_EDITOR, TUI_POLISH_LANGUAGE_ADDON_TABLE, TUI_POLISH_LANGUAGE_CORE, TUI_POLISH_LANGUAGE_COUNTRIES, TUI_POLISH_LANGUAGE_KIT, TUI_POLISH_LANGUAGE_LAYOUT };
